import React, { useEffect, useState } from 'react';
import { Radio, ConfigProvider } from 'antd';
import { addDays, startOfToday, format } from 'date-fns';
import { errorToast } from 'components';

import { useShallow } from 'zustand/react/shallow';
import { useContractsStore } from 'storeZustand';

const today = startOfToday();
const tomorrowDate = addDays(today, 1);
const formattedToday = format(today, 'yyyy-MM-dd');
const formattedTomorrow = format(tomorrowDate, 'yyyy-MM-dd');

const CustomRadioDate = ({ selectedCity }) => {
	const [selectedDate, setSelectedDate] = useState('today');

	// Договоры клиента
	const [
		addFilter,
		filters,
		getContractsParams
	] = useContractsStore(useShallow((state) => [
		state.addFilter,
		state.filters,
		state.getContractsParams
	]));

	useEffect(() => {
		const filtersDate = {
			city: selectedCity,
			start_date: selectedDate === 'today' ? formattedToday : null,
			end_date: selectedDate === 'today' ? formattedTomorrow : null
		}

		const fetchData = async () => {
			try {
				await getContractsParams(filtersDate);
			} catch (error) {
				errorToast('Произошла ошибка при загрузке договоров клиентов.');
			}
		}

		if (selectedCity) fetchData();

		addFilter(filtersDate);
	}, [selectedCity]);

	const handleRadioChange = (event) => {
		const value = event.target.value;
		setSelectedDate(value);

		const filtersDate = {
			city: selectedCity,
			start_date: value === 'today' ? formattedToday : null,
			end_date: value === 'today' ? formattedTomorrow : null
		}

		addFilter(filtersDate);
	};

	return (
		<ConfigProvider
			theme={{
				components: {
					Radio: {
						buttonSolidCheckedBg: '#4eb47f',
						buttonSolidCheckedActiveBg: '#4eb47f',
						buttonSolidCheckedHoverBg: '#4eb47f',
						buttonColor: '#6063aa',
						algorithm: true,
					},
				},
			}}
		>
			<Radio.Group
				value={selectedDate}
				buttonStyle="solid"
				onChange={handleRadioChange}
			>
				<Radio.Button value="all">Весь период</Radio.Button>
				<Radio.Button value="today">Сегодня</Radio.Button>
			</Radio.Group>
		</ConfigProvider>

	);
};

export default CustomRadioDate;